function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3704 132.023H24.2137C24.2137 117.161 14.697 105.141 2.99261 105.141V100.989C16.9942 100.989 28.3704 114.976 28.3704 132.023Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3701 132.023H24.2134C24.2134 114.867 35.5896 100.989 49.5912 100.989V105.141C37.8868 105.141 28.3701 117.271 28.3701 132.023Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M47.4736 -21.0233L46.37 410.94L50.5267 410.951L51.6303 -21.0127L47.4736 -21.0233Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1473 -20.9406L23.0437 411.023L27.2004 411.034L28.3041 -20.93L24.1473 -20.9406Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M70.2909 -20.959L69.1873 411.005L73.344 411.015L74.4477 -20.9484L70.2909 -20.959Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3704 108.966H24.2137C24.2137 94.1047 14.697 82.0844 2.99261 82.0844V77.932C16.9942 77.932 28.3704 91.9192 28.3704 108.966Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3701 108.966H24.2134C24.2134 91.8099 35.5896 77.9319 49.5912 77.9319V82.0844C37.8868 82.1937 28.3701 94.2139 28.3701 108.966Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3704 85.253H24.2137C24.2137 70.3916 14.697 58.3714 2.99261 58.3714V54.2189C16.9942 54.2189 28.3704 68.2061 28.3704 85.253Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3701 85.253H24.2134C24.2134 68.0968 35.5896 54.2189 49.5912 54.2189V58.3714C37.8868 58.3714 28.3701 70.5009 28.3701 85.253Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M74.5317 132.023H70.375C70.375 117.161 60.8583 105.141 49.1539 105.141V100.989C63.1555 100.989 74.5317 114.976 74.5317 132.023Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M74.5316 132.023H70.3749C70.3749 114.867 81.7512 100.989 95.7527 100.989V105.141C84.0483 105.141 74.5316 117.271 74.5316 132.023Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M74.5317 108.966H70.375C70.375 94.1047 60.8583 82.0844 49.1539 82.0844V77.932C63.1555 77.932 74.5317 91.9192 74.5317 108.966Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M74.5316 108.966H70.3749C70.3749 91.8099 81.7512 77.9319 95.7527 77.9319V82.0844C84.0483 82.1937 74.5316 94.2139 74.5316 108.966Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M74.5317 85.253H70.375C70.375 70.3916 60.8583 58.3714 49.1539 58.3714V54.2189C63.1555 54.2189 74.5317 68.2061 74.5317 85.253Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M74.5316 85.253H70.3749C70.3749 68.0968 81.7512 54.2189 95.7527 54.2189V58.3714C84.0483 58.3714 74.5316 70.5009 74.5316 85.253Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3704 62.3055H24.2137C24.2137 47.4441 14.697 35.4238 2.99261 35.4238V31.2714C16.9942 31.2714 28.3704 45.2586 28.3704 62.3055Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3701 62.3054H24.2134C24.2134 45.1492 35.5896 31.2713 49.5912 31.2713V35.4237C37.8868 35.4237 28.3701 47.5533 28.3701 62.3054Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M74.5317 62.3055H70.375C70.375 47.4441 60.8583 35.4238 49.1539 35.4238V31.2714C63.1555 31.2714 74.5317 45.2586 74.5317 62.3055Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M74.5316 62.3054H70.3749C70.3749 45.1492 81.7512 31.2713 95.7527 31.2713V35.4237C84.0483 35.4237 74.5316 47.5533 74.5316 62.3054Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M93.8433 -21.0335L92.7396 410.93L96.8963 410.941L98 -21.0229L93.8433 -21.0335Z",
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M1.10363 -21.0126L0 410.951L4.15671 410.962L5.26034 -21.002L1.10363 -21.0126Z",
  fill: "white"
});

var SvgIcoOrdersBoard = function SvgIcoOrdersBoard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 146,
    viewBox: "0 0 98 146",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoOrdersBoard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-ordersBoard.0c604822.svg";
export { ForwardRef as ReactComponent };